__webpack_require__.p = "https://webview.app.bspot.com/";